import { FC } from 'react'
import clsx from 'clsx'
import Image from 'next/image'

import Auth from 'store/auth'
import CommentSend from './comment-send/comment-send'

import { ICommentDataset } from 'constants/types/webinar.types'
import { STATIC_URL } from 'constants/data'

import styles from './comment-item.module.scss'

const imgPath = {
  iconClose: `${STATIC_URL}/filters/icon_close.svg`,
  iconVerified: `${STATIC_URL}/comment/icon_verified.svg`,
}

interface ICommentItem extends ICommentDataset {
  deleteComment: (id: number | string) => void
  isAllowComment?: boolean
}

const CommentItem: FC<ICommentItem> = ({
  user,
  _id,
  text,
  handleSendAnswer,
  deleteComment,
  modificator,
  parentCommentId,
  isAllowComment,
}: ICommentItem) => {
  const { isAuthorized, isFilledUser, isSponsor, isAdmin, userProfile } = Auth.useAuth()

  const lastName = user?.lastName || ''
  const firstName = user?.firstName || ''
  const secondName = user?.secondName || ''
  const isAdminComment = user?.isAdmin || false
  const isLecturerComment = user?.isLecturer || false

  const fullName = isAdminComment
    ? 'Администратор Medpoint'
    : `${lastName} ${firstName} ${secondName}`

  const handleDeleteComment = () => deleteComment(_id)

  return (
    <div
      className={clsx({
        [modificator as string]: modificator,
      })}
    >
      <div className={styles.commentHeader}>
        <div className={styles.commentInfo}>
          <div className={styles.commentData}>
            <p
              className={clsx(styles.name, {
                [styles.adminName]: isAdminComment,
                [styles.lecturerName]: isLecturerComment,
              })}
            >
              {fullName}
            </p>
            {(isAdminComment || isLecturerComment) && (
              <Image
                src={imgPath.iconVerified}
                alt="Подтвержденный аккаунт"
                className={styles.verified}
                width="16"
                height="16"
              />
            )}
          </div>
        </div>
        {(isAdmin || Number(userProfile?.id) === Number(user?.id)) && (
          <Image
            src={imgPath.iconClose}
            alt="иконка удаления комментариев"
            title="Удалить комментарий"
            className={styles.iconClose}
            onClick={handleDeleteComment}
            width="15"
            height="15"
          />
        )}
      </div>
      <p className={styles.commentContent}>{text}</p>
      {isAuthorized && (isFilledUser || isSponsor) && isAllowComment && (
        <CommentSend
          id={_id}
          handleSendAnswer={handleSendAnswer}
          parentCommentId={parentCommentId}
        />
      )}
    </div>
  )
}

export default CommentItem
